import styled from "styled-components";

export default styled.div`
  padding: 0.25em 6em 0.25em 2em;
  display: flex;
  align-items: center;
`;
